import { getPersistedValue, setPersistedValue } from 'shared/utils/persisted-values';
import { Group } from './types';

const GROUPS_LOCAL_STORAGE_KEY = 'dutchie:ab:g';
const CONVERSIONS_LOCAL_STORAGE_KEY = 'dutchie:ab:c';

const getGroupsFromLocalStorage = (): Record<string, Group> | null => {
  const experimentGroupValues = new Set<unknown>(Object.values(Group));

  try {
    const json = getPersistedValue(GROUPS_LOCAL_STORAGE_KEY, {});
    const entries = Object.entries(json);
    const validatedEntries = entries.filter(([, b]) => experimentGroupValues.has(b)) as [string, Group][];
    return Object.fromEntries(validatedEntries);
  } catch (e) {
    return {};
  }
};

let groupsCache: Record<string, Group> | null = getGroupsFromLocalStorage();
export const getGroups = (): Record<string, Group> | null => groupsCache;

// exported for testing
export const resetGroupsCache = (): void => {
  groupsCache = getGroupsFromLocalStorage();
};

export const addGroupToLocalStorage = (experimentId: string, group: Group): void => {
  // don't use cache in case value was updated in another store
  const groups = getGroupsFromLocalStorage();
  if (!groups) {
    return;
  }

  setPersistedValue(GROUPS_LOCAL_STORAGE_KEY, { ...groups, [experimentId]: group });
  resetGroupsCache();
};

export const storeConversion = (experimentId: string): void => {
  const existingItems: string = getPersistedValue(CONVERSIONS_LOCAL_STORAGE_KEY);
  setPersistedValue(CONVERSIONS_LOCAL_STORAGE_KEY, existingItems ? `${existingItems},${experimentId}` : experimentId);
};

export const hasConverted = (experimentId: string): boolean =>
  !!getPersistedValue(CONVERSIONS_LOCAL_STORAGE_KEY, '')
    .split(',')
    .find((id) => experimentId === id);
